import { useState, useRef, useContext, useEffect } from "react";
import { Form, Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import API from "../services/api";
import classes from "./UploadFile.module.css";
import CustomButton from "./common/CustomButton";
import toast from "react-hot-toast";
import MultiSelect from "../components/common/MultiSelect";
import { GroupContext } from "../services/contexts/GroupContext";

const ALLOWED_MIME_TYPES = ["application/pdf"];

const EMPTY_FILE_STATE = {
  pdfFile: null,
  documentTitle: "",
  createdDate: `${new Date().getFullYear()}-${
    new Date().getMonth() + 1
  }-${new Date().getDate()}`,
  selectedGroups: [],
};

function UploadFile(props) {
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(EMPTY_FILE_STATE);
  const { globalData } = useContext(GroupContext);
  const { handleUploadClose, showUploadModal, getFiles, folderId, path } =
    props;

  useEffect(()=>{
    setFile(EMPTY_FILE_STATE);
  }, [showUploadModal])

  const onFileChange = (e) => {
    const uplodedFile = e.target.files[0];
    const noFileUploaded = uplodedFile === undefined || uplodedFile === null;
    const fileTypeIsAllow =
      !noFileUploaded && ALLOWED_MIME_TYPES.includes(uplodedFile.type);

    if (noFileUploaded) {
      setFile((prev) => ({ ...prev, pdfFile: null }));
    } else if (fileTypeIsAllow) {
      setFile((prev) => ({ ...prev, pdfFile: e.target.files[0] }));
    } else {
      toast.error(
        `File type: ${uplodedFile.name.split(".").pop()} is not allow`
      );
      setFile((prev) => ({ ...prev, pdfFile: null }));
      fileInputRef.current.value = null;
    }
  };
  const isFormDirty = () => {
    return file.pdfFile === null || file.documentTitle === "";
  };
  const onFileUpload = () => {
    if (file.pdfFile === null || file.pdfFile === undefined) {
      alert("no file selected");
    } else if (file.documentTitle.length === 0) {
      alert("Document Title is required");
    } else {
      const formData = new FormData();
      formData.append("file", file.pdfFile);
      formData.append("document_title", file.documentTitle);
      formData.append("folder_id", folderId);
      formData.append("path", path);
      formData.append("created_date", file.createdDate);
      formData.append(
        "group_ids",
        JSON.stringify(file.selectedGroups.map((group) => group.group_id))
      );
      API.post(`/admin/uploadfile`, formData)
        .then((res) => {
          if (res.status === 200) {
            getFiles();
            alert(res.data.msg);
          }
        })
        .catch((error) => {
          alert(error.response.data.msg || error.response.data.message);
        })
        .finally(() => {
          handleUploadClose();
        });
    }
  };

  return (
    <div>
      <Modal
        show={showUploadModal}
        onHide={handleUploadClose}
        contentClassName={classes.upload_modal_content}
        dialogClassName={classes.upload_modal_dialog}
        backdrop="static"
      >
        <Modal.Header className="_g-modal-header_">
          <div className="_g-close-button-anchor_">
            <div className="_g-close-button_" onClick={handleUploadClose}>
              &#x2715;
            </div>
          </div>
          Upload File
        </Modal.Header>

        <Modal.Body className={classes.upload_modal_body}>
          <div>
            <div className="d-block">
              <div className={classes.input_wrapper}>
                <Form.Group className={classes.input_label_wrapper}>
                  <Form.Label>Document Title </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Document title"
                    name="documentTitle"
                    maxLength={128}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        onFileUpload();
                      }
                    }}
                    onChange={(e) => {
                      setFile(prev=>({...prev, documentTitle: e.target.value}));
                      if (e.target.value.length === 128) {
                        toast.error(
                          `File document title can not be longer than 128 characters.`
                        );
                      }
                    }}
                  />
                </Form.Group>

                <Form.Group className={classes.input_label_wrapper}>
                  <Form.Label>Created Date</Form.Label>
                  <Form.Control
                    type="date"
                    min="1990-01-01"
                    onChange={(e) => {
                      setFile((prev)=> ({...prev,  createdDate: e.target.value}));
                    }}
                  />
                </Form.Group>
              </div>

              <div className={classes.attachment_wrapper}>
                <input
                  type="file"
                  accept=".pdf"
                  placeholder="file"
                  onChange={onFileChange}
                  ref={fileInputRef}
                  className={classes.attachment_choose}
                />
                <i style={{ color: "red" }}>*PDF file only</i>
              </div>

              <div className={classes.group_select}>
                <MultiSelect
                  label="Assign group"
                  options={globalData.allGroups}
                  selected={file.selectedGroups}
                  onChange={(groups) => setFile((prev)=> ({...prev, selectedGroups: groups}))}
                  placeholder="Please Select"
                />
              </div>
            </div>
          </div>
          <div className="_g-modal-button-wrapper_">
            <CustomButton
              variant="outline-secondary"
              onClick={() => handleUploadClose()}
            >
              Close
            </CustomButton>
            <CustomButton onClick={onFileUpload} disabled={isFormDirty()}>
              Upload file
            </CustomButton>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default UploadFile;

UploadFile.propTypes = {
  handleUploadClose: PropTypes.func.isRequired,
  showUploadModal: PropTypes.bool.isRequired,
};
